import React from "react";
import "./Testimonials.css";
import {Pagination}  from 'swiper'
import {Swiper, SwiperSlide} from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'

function Testimonials() {
  const data = [
    {
      avatar: "../assets/avatar1.jpg",
      name: "Tina Snow",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda magni voluptatum sit sequi dolorem omnis velit aliquam repellendus impedit. Perferendis eaque odit voluptate ducimus reiciendis, quibusdam in minus ratione cum?",
    },
    {
      avatar: "../assets/avatar2.jpg",
      name: "Shatta Wale",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda magni voluptatum sit sequi dolorem omnis velit aliquam repellendus impedit. Perferendis eaque odit voluptate ducimus reiciendis, quibusdam in minus ratione cum?",
    },
    {
      avatar: "../assets/avatar3.jpg",
      name: "Kwame Despite",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda magni voluptatum sit sequi dolorem omnis velit aliquam repellendus impedit. Perferendis eaque odit voluptate ducimus reiciendis, quibusdam in minus ratione cum?",
    },
    {
      avatar: "../assets/avatar4.jpg",
      name: "Nana Ama McBrown",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda magni voluptatum sit sequi dolorem omnis velit aliquam repellendus impedit. Perferendis eaque odit voluptate ducimus reiciendis, quibusdam in minus ratione cum?",
    },
  ];

  return (
    <section id="testimonials">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container"
      modules={[Pagination]} spaceBetween={40}
      slidesPerView={1}
      pagination={{clickable:true}}
      >
        {data.map(({ avatar, name, review }, index) => {
          return (
            <SwiperSlide key={index} className="testimonial">
              <div className="Client__avatar">
                <img src={avatar} alt="" />
              </div>
              <h5 className="Client__name">{name}</h5>
              <small className="Client__review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
}

export default Testimonials;
